/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountCreditsRouteImport } from './routes/_app/account-credits'
import { Route as AppAssistRouteImport } from './routes/_app/assist'
import { Route as AppCashRouteImport } from './routes/_app/cash'
import { Route as AppCustomersRouteImport } from './routes/_app/customers'
import { Route as AppGiftCardsRouteImport } from './routes/_app/gift-cards'
import { Route as AppInventoryRouteImport } from './routes/_app/inventory'
import { Route as AppLookupRouteImport } from './routes/_app/lookup'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppOrganizeRouteImport } from './routes/_app/organize'
import { Route as AppPricingRouteImport } from './routes/_app/pricing'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppPurchasingRouteImport } from './routes/_app/purchasing'
import { Route as AppRecoveryRouteImport } from './routes/_app/recovery'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppReturnsRouteImport } from './routes/_app/returns'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSystemRouteImport } from './routes/_app/system'
import { Route as AppTransactionsRouteImport } from './routes/_app/transactions'
import { Route as AppVendorsRouteImport } from './routes/_app/vendors'
import { Route as AppCustomersIdRouteImport } from './routes/_app/customers_.$id'
import { Route as AppCustomersNewRouteImport } from './routes/_app/customers_.new'
import { Route as AppGiftCardsIdRouteImport } from './routes/_app/gift-cards_.$id'
import { Route as AppGiftCardsBatchesRouteImport } from './routes/_app/gift-cards_.batches'
import { Route as AppOrdersIdRouteImport } from './routes/_app/orders_.$id'
import { Route as AppOrdersNewRouteImport } from './routes/_app/orders_.new'
import { Route as AppProductsIdRouteImport } from './routes/_app/products_.$id'
import { Route as AppProductsFamiliesRouteImport } from './routes/_app/products_.families'
import { Route as AppProductsNewRouteImport } from './routes/_app/products_.new'
import { Route as AppPurchasingIdRouteImport } from './routes/_app/purchasing.$id'
import { Route as AppPurchasingImportRouteImport } from './routes/_app/purchasing.import'
import { Route as AppPurchasingNewRouteImport } from './routes/_app/purchasing.new'
import { Route as AppPurchasingReceiveRouteImport } from './routes/_app/purchasing.receive'
import { Route as AppPurchasingFollowUpsRouteImport } from './routes/_app/purchasing_.follow-ups'
import { Route as AppPurchasingFreightRouteImport } from './routes/_app/purchasing_.freight'
import { Route as AppPurchasingGuideRouteImport } from './routes/_app/purchasing_.guide'
import { Route as AppSettingsLabelTemplatesRouteImport } from './routes/_app/settings_.label-templates'
import { Route as AppSettingsQuickPanelRouteImport } from './routes/_app/settings_.quick-panel'
import { Route as AppSystemIndexRouteImport } from './routes/_app/system.index'
import { Route as AppSystemFloorDevicesRouteImport } from './routes/_app/system.floor-devices'
import { Route as AppSystemRegistersRouteImport } from './routes/_app/system.registers'
import { Route as AppSystemStaffRouteImport } from './routes/_app/system.staff'
import { Route as AppSystemSyncRouteImport } from './routes/_app/system.sync'
import { Route as AppTransactionsIdRouteImport } from './routes/_app/transactions_.$id'
import { Route as AppVendorsIdRouteImport } from './routes/_app/vendors.$id'
import { Route as AppVendorsCostApprovalsRouteImport } from './routes/_app/vendors.cost-approvals'
import { Route as AppVendorsNewRouteImport } from './routes/_app/vendors.new'
import { Route as AppVendorsCatalogsRouteImport } from './routes/_app/vendors_.catalogs'
import { Route as AppVendorsDropOffLocationsRouteImport } from './routes/_app/vendors_.drop-off-locations'
import { Route as AppGiftCardsBatchesIdRouteImport } from './routes/_app/gift-cards_.batches_.$id'
import { Route as AppGiftCardsBatchesNewRouteImport } from './routes/_app/gift-cards_.batches_.new'
import { Route as AppOrdersIdPickRouteImport } from './routes/_app/orders_.$id_.pick'
import { Route as AppPurchasingIdInvoiceRouteImport } from './routes/_app/purchasing_.$id_.invoice'
import { Route as AppPurchasingGuideVendorIdRouteImport } from './routes/_app/purchasing_.guide_.$vendorId'
import { Route as AppSystemRegistersIdRouteImport } from './routes/_app/system.registers_.$id'
import { Route as AppSystemStaffIdRouteImport } from './routes/_app/system.staff_.$id'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountCreditsRoute = AppAccountCreditsRouteImport.update({
  id: '/account-credits',
  path: '/account-credits',
  getParentRoute: () => AppRoute,
} as any)
const AppAssistRoute = AppAssistRouteImport.update({
  id: '/assist',
  path: '/assist',
  getParentRoute: () => AppRoute,
} as any)
const AppCashRoute = AppCashRouteImport.update({
  id: '/cash',
  path: '/cash',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppGiftCardsRoute = AppGiftCardsRouteImport.update({
  id: '/gift-cards',
  path: '/gift-cards',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppLookupRoute = AppLookupRouteImport.update({
  id: '/lookup',
  path: '/lookup',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizeRoute = AppOrganizeRouteImport.update({
  id: '/organize',
  path: '/organize',
  getParentRoute: () => AppRoute,
} as any)
const AppPricingRoute = AppPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingRoute = AppPurchasingRouteImport.update({
  id: '/purchasing',
  path: '/purchasing',
  getParentRoute: () => AppRoute,
} as any)
const AppRecoveryRoute = AppRecoveryRouteImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppReturnsRoute = AppReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemRoute = AppSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsRoute = AppTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AppRoute,
} as any)
const AppVendorsRoute = AppVendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers_/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersNewRoute = AppCustomersNewRouteImport.update({
  id: '/customers_/new',
  path: '/customers/new',
  getParentRoute: () => AppRoute,
} as any)
const AppGiftCardsIdRoute = AppGiftCardsIdRouteImport.update({
  id: '/gift-cards_/$id',
  path: '/gift-cards/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppGiftCardsBatchesRoute = AppGiftCardsBatchesRouteImport.update({
  id: '/gift-cards_/batches',
  path: '/gift-cards/batches',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIdRoute = AppOrdersIdRouteImport.update({
  id: '/orders_/$id',
  path: '/orders/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: '/orders_/new',
  path: '/orders/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIdRoute = AppProductsIdRouteImport.update({
  id: '/products_/$id',
  path: '/products/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsFamiliesRoute = AppProductsFamiliesRouteImport.update({
  id: '/products_/families',
  path: '/products/families',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsNewRoute = AppProductsNewRouteImport.update({
  id: '/products_/new',
  path: '/products/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingIdRoute = AppPurchasingIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppPurchasingRoute,
} as any)
const AppPurchasingImportRoute = AppPurchasingImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AppPurchasingRoute,
} as any)
const AppPurchasingNewRoute = AppPurchasingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppPurchasingRoute,
} as any)
const AppPurchasingReceiveRoute = AppPurchasingReceiveRouteImport.update({
  id: '/receive',
  path: '/receive',
  getParentRoute: () => AppPurchasingRoute,
} as any)
const AppPurchasingFollowUpsRoute = AppPurchasingFollowUpsRouteImport.update({
  id: '/purchasing_/follow-ups',
  path: '/purchasing/follow-ups',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingFreightRoute = AppPurchasingFreightRouteImport.update({
  id: '/purchasing_/freight',
  path: '/purchasing/freight',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingGuideRoute = AppPurchasingGuideRouteImport.update({
  id: '/purchasing_/guide',
  path: '/purchasing/guide',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsLabelTemplatesRoute =
  AppSettingsLabelTemplatesRouteImport.update({
    id: '/settings_/label-templates',
    path: '/settings/label-templates',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsQuickPanelRoute = AppSettingsQuickPanelRouteImport.update({
  id: '/settings_/quick-panel',
  path: '/settings/quick-panel',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemIndexRoute = AppSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSystemRoute,
} as any)
const AppSystemFloorDevicesRoute = AppSystemFloorDevicesRouteImport.update({
  id: '/floor-devices',
  path: '/floor-devices',
  getParentRoute: () => AppSystemRoute,
} as any)
const AppSystemRegistersRoute = AppSystemRegistersRouteImport.update({
  id: '/registers',
  path: '/registers',
  getParentRoute: () => AppSystemRoute,
} as any)
const AppSystemStaffRoute = AppSystemStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppSystemRoute,
} as any)
const AppSystemSyncRoute = AppSystemSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AppSystemRoute,
} as any)
const AppTransactionsIdRoute = AppTransactionsIdRouteImport.update({
  id: '/transactions_/$id',
  path: '/transactions/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppVendorsIdRoute = AppVendorsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppVendorsRoute,
} as any)
const AppVendorsCostApprovalsRoute = AppVendorsCostApprovalsRouteImport.update({
  id: '/cost-approvals',
  path: '/cost-approvals',
  getParentRoute: () => AppVendorsRoute,
} as any)
const AppVendorsNewRoute = AppVendorsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppVendorsRoute,
} as any)
const AppVendorsCatalogsRoute = AppVendorsCatalogsRouteImport.update({
  id: '/vendors_/catalogs',
  path: '/vendors/catalogs',
  getParentRoute: () => AppRoute,
} as any)
const AppVendorsDropOffLocationsRoute =
  AppVendorsDropOffLocationsRouteImport.update({
    id: '/vendors_/drop-off-locations',
    path: '/vendors/drop-off-locations',
    getParentRoute: () => AppRoute,
  } as any)
const AppGiftCardsBatchesIdRoute = AppGiftCardsBatchesIdRouteImport.update({
  id: '/gift-cards_/batches_/$id',
  path: '/gift-cards/batches/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppGiftCardsBatchesNewRoute = AppGiftCardsBatchesNewRouteImport.update({
  id: '/gift-cards_/batches_/new',
  path: '/gift-cards/batches/new',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIdPickRoute = AppOrdersIdPickRouteImport.update({
  id: '/orders_/$id_/pick',
  path: '/orders/$id/pick',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingIdInvoiceRoute = AppPurchasingIdInvoiceRouteImport.update({
  id: '/purchasing_/$id_/invoice',
  path: '/purchasing/$id/invoice',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingGuideVendorIdRoute =
  AppPurchasingGuideVendorIdRouteImport.update({
    id: '/purchasing_/guide_/$vendorId',
    path: '/purchasing/guide/$vendorId',
    getParentRoute: () => AppRoute,
  } as any)
const AppSystemRegistersIdRoute = AppSystemRegistersIdRouteImport.update({
  id: '/registers_/$id',
  path: '/registers/$id',
  getParentRoute: () => AppSystemRoute,
} as any)
const AppSystemStaffIdRoute = AppSystemStaffIdRouteImport.update({
  id: '/staff_/$id',
  path: '/staff/$id',
  getParentRoute: () => AppSystemRoute,
} as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/account-credits': typeof AppAccountCreditsRoute
  '/assist': typeof AppAssistRoute
  '/cash': typeof AppCashRoute
  '/customers': typeof AppCustomersRoute
  '/gift-cards': typeof AppGiftCardsRoute
  '/inventory': typeof AppInventoryRoute
  '/lookup': typeof AppLookupRoute
  '/orders': typeof AppOrdersRoute
  '/organize': typeof AppOrganizeRoute
  '/pricing': typeof AppPricingRoute
  '/products': typeof AppProductsRoute
  '/purchasing': typeof AppPurchasingRouteWithChildren
  '/recovery': typeof AppRecoveryRoute
  '/reports': typeof AppReportsRoute
  '/returns': typeof AppReturnsRoute
  '/settings': typeof AppSettingsRoute
  '/system': typeof AppSystemRouteWithChildren
  '/transactions': typeof AppTransactionsRoute
  '/vendors': typeof AppVendorsRouteWithChildren
  '/customers/$id': typeof AppCustomersIdRoute
  '/customers/new': typeof AppCustomersNewRoute
  '/gift-cards/$id': typeof AppGiftCardsIdRoute
  '/gift-cards/batches': typeof AppGiftCardsBatchesRoute
  '/orders/$id': typeof AppOrdersIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/products/$id': typeof AppProductsIdRoute
  '/products/families': typeof AppProductsFamiliesRoute
  '/products/new': typeof AppProductsNewRoute
  '/purchasing/$id': typeof AppPurchasingIdRoute
  '/purchasing/import': typeof AppPurchasingImportRoute
  '/purchasing/new': typeof AppPurchasingNewRoute
  '/purchasing/receive': typeof AppPurchasingReceiveRoute
  '/purchasing/follow-ups': typeof AppPurchasingFollowUpsRoute
  '/purchasing/freight': typeof AppPurchasingFreightRoute
  '/purchasing/guide': typeof AppPurchasingGuideRoute
  '/settings/label-templates': typeof AppSettingsLabelTemplatesRoute
  '/settings/quick-panel': typeof AppSettingsQuickPanelRoute
  '/system/floor-devices': typeof AppSystemFloorDevicesRoute
  '/system/registers': typeof AppSystemRegistersRoute
  '/system/staff': typeof AppSystemStaffRoute
  '/system/sync': typeof AppSystemSyncRoute
  '/transactions/$id': typeof AppTransactionsIdRoute
  '/vendors/$id': typeof AppVendorsIdRoute
  '/vendors/cost-approvals': typeof AppVendorsCostApprovalsRoute
  '/vendors/new': typeof AppVendorsNewRoute
  '/vendors/catalogs': typeof AppVendorsCatalogsRoute
  '/vendors/drop-off-locations': typeof AppVendorsDropOffLocationsRoute
  '/system/': typeof AppSystemIndexRoute
  '/gift-cards/batches/$id': typeof AppGiftCardsBatchesIdRoute
  '/gift-cards/batches/new': typeof AppGiftCardsBatchesNewRoute
  '/orders/$id/pick': typeof AppOrdersIdPickRoute
  '/purchasing/$id/invoice': typeof AppPurchasingIdInvoiceRoute
  '/purchasing/guide/$vendorId': typeof AppPurchasingGuideVendorIdRoute
  '/system/registers/$id': typeof AppSystemRegistersIdRoute
  '/system/staff/$id': typeof AppSystemStaffIdRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/login': typeof LoginRoute
  '/account-credits': typeof AppAccountCreditsRoute
  '/assist': typeof AppAssistRoute
  '/cash': typeof AppCashRoute
  '/customers': typeof AppCustomersRoute
  '/gift-cards': typeof AppGiftCardsRoute
  '/inventory': typeof AppInventoryRoute
  '/lookup': typeof AppLookupRoute
  '/orders': typeof AppOrdersRoute
  '/organize': typeof AppOrganizeRoute
  '/pricing': typeof AppPricingRoute
  '/products': typeof AppProductsRoute
  '/purchasing': typeof AppPurchasingRouteWithChildren
  '/recovery': typeof AppRecoveryRoute
  '/reports': typeof AppReportsRoute
  '/returns': typeof AppReturnsRoute
  '/settings': typeof AppSettingsRoute
  '/transactions': typeof AppTransactionsRoute
  '/vendors': typeof AppVendorsRouteWithChildren
  '/': typeof AppIndexRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/customers/new': typeof AppCustomersNewRoute
  '/gift-cards/$id': typeof AppGiftCardsIdRoute
  '/gift-cards/batches': typeof AppGiftCardsBatchesRoute
  '/orders/$id': typeof AppOrdersIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/products/$id': typeof AppProductsIdRoute
  '/products/families': typeof AppProductsFamiliesRoute
  '/products/new': typeof AppProductsNewRoute
  '/purchasing/$id': typeof AppPurchasingIdRoute
  '/purchasing/import': typeof AppPurchasingImportRoute
  '/purchasing/new': typeof AppPurchasingNewRoute
  '/purchasing/receive': typeof AppPurchasingReceiveRoute
  '/purchasing/follow-ups': typeof AppPurchasingFollowUpsRoute
  '/purchasing/freight': typeof AppPurchasingFreightRoute
  '/purchasing/guide': typeof AppPurchasingGuideRoute
  '/settings/label-templates': typeof AppSettingsLabelTemplatesRoute
  '/settings/quick-panel': typeof AppSettingsQuickPanelRoute
  '/system/floor-devices': typeof AppSystemFloorDevicesRoute
  '/system/registers': typeof AppSystemRegistersRoute
  '/system/staff': typeof AppSystemStaffRoute
  '/system/sync': typeof AppSystemSyncRoute
  '/transactions/$id': typeof AppTransactionsIdRoute
  '/vendors/$id': typeof AppVendorsIdRoute
  '/vendors/cost-approvals': typeof AppVendorsCostApprovalsRoute
  '/vendors/new': typeof AppVendorsNewRoute
  '/vendors/catalogs': typeof AppVendorsCatalogsRoute
  '/vendors/drop-off-locations': typeof AppVendorsDropOffLocationsRoute
  '/system': typeof AppSystemIndexRoute
  '/gift-cards/batches/$id': typeof AppGiftCardsBatchesIdRoute
  '/gift-cards/batches/new': typeof AppGiftCardsBatchesNewRoute
  '/orders/$id/pick': typeof AppOrdersIdPickRoute
  '/purchasing/$id/invoice': typeof AppPurchasingIdInvoiceRoute
  '/purchasing/guide/$vendorId': typeof AppPurchasingGuideVendorIdRoute
  '/system/registers/$id': typeof AppSystemRegistersIdRoute
  '/system/staff/$id': typeof AppSystemStaffIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/account-credits': typeof AppAccountCreditsRoute
  '/_app/assist': typeof AppAssistRoute
  '/_app/cash': typeof AppCashRoute
  '/_app/customers': typeof AppCustomersRoute
  '/_app/gift-cards': typeof AppGiftCardsRoute
  '/_app/inventory': typeof AppInventoryRoute
  '/_app/lookup': typeof AppLookupRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/organize': typeof AppOrganizeRoute
  '/_app/pricing': typeof AppPricingRoute
  '/_app/products': typeof AppProductsRoute
  '/_app/purchasing': typeof AppPurchasingRouteWithChildren
  '/_app/recovery': typeof AppRecoveryRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/returns': typeof AppReturnsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/system': typeof AppSystemRouteWithChildren
  '/_app/transactions': typeof AppTransactionsRoute
  '/_app/vendors': typeof AppVendorsRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/customers_/$id': typeof AppCustomersIdRoute
  '/_app/customers_/new': typeof AppCustomersNewRoute
  '/_app/gift-cards_/$id': typeof AppGiftCardsIdRoute
  '/_app/gift-cards_/batches': typeof AppGiftCardsBatchesRoute
  '/_app/orders_/$id': typeof AppOrdersIdRoute
  '/_app/orders_/new': typeof AppOrdersNewRoute
  '/_app/products_/$id': typeof AppProductsIdRoute
  '/_app/products_/families': typeof AppProductsFamiliesRoute
  '/_app/products_/new': typeof AppProductsNewRoute
  '/_app/purchasing/$id': typeof AppPurchasingIdRoute
  '/_app/purchasing/import': typeof AppPurchasingImportRoute
  '/_app/purchasing/new': typeof AppPurchasingNewRoute
  '/_app/purchasing/receive': typeof AppPurchasingReceiveRoute
  '/_app/purchasing_/follow-ups': typeof AppPurchasingFollowUpsRoute
  '/_app/purchasing_/freight': typeof AppPurchasingFreightRoute
  '/_app/purchasing_/guide': typeof AppPurchasingGuideRoute
  '/_app/settings_/label-templates': typeof AppSettingsLabelTemplatesRoute
  '/_app/settings_/quick-panel': typeof AppSettingsQuickPanelRoute
  '/_app/system/floor-devices': typeof AppSystemFloorDevicesRoute
  '/_app/system/registers': typeof AppSystemRegistersRoute
  '/_app/system/staff': typeof AppSystemStaffRoute
  '/_app/system/sync': typeof AppSystemSyncRoute
  '/_app/transactions_/$id': typeof AppTransactionsIdRoute
  '/_app/vendors/$id': typeof AppVendorsIdRoute
  '/_app/vendors/cost-approvals': typeof AppVendorsCostApprovalsRoute
  '/_app/vendors/new': typeof AppVendorsNewRoute
  '/_app/vendors_/catalogs': typeof AppVendorsCatalogsRoute
  '/_app/vendors_/drop-off-locations': typeof AppVendorsDropOffLocationsRoute
  '/_app/system/': typeof AppSystemIndexRoute
  '/_app/gift-cards_/batches_/$id': typeof AppGiftCardsBatchesIdRoute
  '/_app/gift-cards_/batches_/new': typeof AppGiftCardsBatchesNewRoute
  '/_app/orders_/$id_/pick': typeof AppOrdersIdPickRoute
  '/_app/purchasing_/$id_/invoice': typeof AppPurchasingIdInvoiceRoute
  '/_app/purchasing_/guide_/$vendorId': typeof AppPurchasingGuideVendorIdRoute
  '/_app/system/registers_/$id': typeof AppSystemRegistersIdRoute
  '/_app/system/staff_/$id': typeof AppSystemStaffIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/login'
    | '/account-credits'
    | '/assist'
    | '/cash'
    | '/customers'
    | '/gift-cards'
    | '/inventory'
    | '/lookup'
    | '/orders'
    | '/organize'
    | '/pricing'
    | '/products'
    | '/purchasing'
    | '/recovery'
    | '/reports'
    | '/returns'
    | '/settings'
    | '/system'
    | '/transactions'
    | '/vendors'
    | '/customers/$id'
    | '/customers/new'
    | '/gift-cards/$id'
    | '/gift-cards/batches'
    | '/orders/$id'
    | '/orders/new'
    | '/products/$id'
    | '/products/families'
    | '/products/new'
    | '/purchasing/$id'
    | '/purchasing/import'
    | '/purchasing/new'
    | '/purchasing/receive'
    | '/purchasing/follow-ups'
    | '/purchasing/freight'
    | '/purchasing/guide'
    | '/settings/label-templates'
    | '/settings/quick-panel'
    | '/system/floor-devices'
    | '/system/registers'
    | '/system/staff'
    | '/system/sync'
    | '/transactions/$id'
    | '/vendors/$id'
    | '/vendors/cost-approvals'
    | '/vendors/new'
    | '/vendors/catalogs'
    | '/vendors/drop-off-locations'
    | '/system/'
    | '/gift-cards/batches/$id'
    | '/gift-cards/batches/new'
    | '/orders/$id/pick'
    | '/purchasing/$id/invoice'
    | '/purchasing/guide/$vendorId'
    | '/system/registers/$id'
    | '/system/staff/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/login'
    | '/account-credits'
    | '/assist'
    | '/cash'
    | '/customers'
    | '/gift-cards'
    | '/inventory'
    | '/lookup'
    | '/orders'
    | '/organize'
    | '/pricing'
    | '/products'
    | '/purchasing'
    | '/recovery'
    | '/reports'
    | '/returns'
    | '/settings'
    | '/transactions'
    | '/vendors'
    | '/'
    | '/customers/$id'
    | '/customers/new'
    | '/gift-cards/$id'
    | '/gift-cards/batches'
    | '/orders/$id'
    | '/orders/new'
    | '/products/$id'
    | '/products/families'
    | '/products/new'
    | '/purchasing/$id'
    | '/purchasing/import'
    | '/purchasing/new'
    | '/purchasing/receive'
    | '/purchasing/follow-ups'
    | '/purchasing/freight'
    | '/purchasing/guide'
    | '/settings/label-templates'
    | '/settings/quick-panel'
    | '/system/floor-devices'
    | '/system/registers'
    | '/system/staff'
    | '/system/sync'
    | '/transactions/$id'
    | '/vendors/$id'
    | '/vendors/cost-approvals'
    | '/vendors/new'
    | '/vendors/catalogs'
    | '/vendors/drop-off-locations'
    | '/system'
    | '/gift-cards/batches/$id'
    | '/gift-cards/batches/new'
    | '/orders/$id/pick'
    | '/purchasing/$id/invoice'
    | '/purchasing/guide/$vendorId'
    | '/system/registers/$id'
    | '/system/staff/$id'
  id:
    | '__root__'
    | '/$'
    | '/_app'
    | '/login'
    | '/_app/account-credits'
    | '/_app/assist'
    | '/_app/cash'
    | '/_app/customers'
    | '/_app/gift-cards'
    | '/_app/inventory'
    | '/_app/lookup'
    | '/_app/orders'
    | '/_app/organize'
    | '/_app/pricing'
    | '/_app/products'
    | '/_app/purchasing'
    | '/_app/recovery'
    | '/_app/reports'
    | '/_app/returns'
    | '/_app/settings'
    | '/_app/system'
    | '/_app/transactions'
    | '/_app/vendors'
    | '/_app/'
    | '/_app/customers_/$id'
    | '/_app/customers_/new'
    | '/_app/gift-cards_/$id'
    | '/_app/gift-cards_/batches'
    | '/_app/orders_/$id'
    | '/_app/orders_/new'
    | '/_app/products_/$id'
    | '/_app/products_/families'
    | '/_app/products_/new'
    | '/_app/purchasing/$id'
    | '/_app/purchasing/import'
    | '/_app/purchasing/new'
    | '/_app/purchasing/receive'
    | '/_app/purchasing_/follow-ups'
    | '/_app/purchasing_/freight'
    | '/_app/purchasing_/guide'
    | '/_app/settings_/label-templates'
    | '/_app/settings_/quick-panel'
    | '/_app/system/floor-devices'
    | '/_app/system/registers'
    | '/_app/system/staff'
    | '/_app/system/sync'
    | '/_app/transactions_/$id'
    | '/_app/vendors/$id'
    | '/_app/vendors/cost-approvals'
    | '/_app/vendors/new'
    | '/_app/vendors_/catalogs'
    | '/_app/vendors_/drop-off-locations'
    | '/_app/system/'
    | '/_app/gift-cards_/batches_/$id'
    | '/_app/gift-cards_/batches_/new'
    | '/_app/orders_/$id_/pick'
    | '/_app/purchasing_/$id_/invoice'
    | '/_app/purchasing_/guide_/$vendorId'
    | '/_app/system/registers_/$id'
    | '/_app/system/staff_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account-credits': {
      id: '/_app/account-credits'
      path: '/account-credits'
      fullPath: '/account-credits'
      preLoaderRoute: typeof AppAccountCreditsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assist': {
      id: '/_app/assist'
      path: '/assist'
      fullPath: '/assist'
      preLoaderRoute: typeof AppAssistRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash': {
      id: '/_app/cash'
      path: '/cash'
      fullPath: '/cash'
      preLoaderRoute: typeof AppCashRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gift-cards': {
      id: '/_app/gift-cards'
      path: '/gift-cards'
      fullPath: '/gift-cards'
      preLoaderRoute: typeof AppGiftCardsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lookup': {
      id: '/_app/lookup'
      path: '/lookup'
      fullPath: '/lookup'
      preLoaderRoute: typeof AppLookupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organize': {
      id: '/_app/organize'
      path: '/organize'
      fullPath: '/organize'
      preLoaderRoute: typeof AppOrganizeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pricing': {
      id: '/_app/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AppPricingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing': {
      id: '/_app/purchasing'
      path: '/purchasing'
      fullPath: '/purchasing'
      preLoaderRoute: typeof AppPurchasingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recovery': {
      id: '/_app/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof AppRecoveryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/returns': {
      id: '/_app/returns'
      path: '/returns'
      fullPath: '/returns'
      preLoaderRoute: typeof AppReturnsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system': {
      id: '/_app/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AppSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions': {
      id: '/_app/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AppTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vendors': {
      id: '/_app/vendors'
      path: '/vendors'
      fullPath: '/vendors'
      preLoaderRoute: typeof AppVendorsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers_/$id': {
      id: '/_app/customers_/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers_/new': {
      id: '/_app/customers_/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AppCustomersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gift-cards_/$id': {
      id: '/_app/gift-cards_/$id'
      path: '/gift-cards/$id'
      fullPath: '/gift-cards/$id'
      preLoaderRoute: typeof AppGiftCardsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gift-cards_/batches': {
      id: '/_app/gift-cards_/batches'
      path: '/gift-cards/batches'
      fullPath: '/gift-cards/batches'
      preLoaderRoute: typeof AppGiftCardsBatchesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders_/$id': {
      id: '/_app/orders_/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof AppOrdersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders_/new': {
      id: '/_app/orders_/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppOrdersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products_/$id': {
      id: '/_app/products_/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof AppProductsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products_/families': {
      id: '/_app/products_/families'
      path: '/products/families'
      fullPath: '/products/families'
      preLoaderRoute: typeof AppProductsFamiliesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products_/new': {
      id: '/_app/products_/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AppProductsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/$id': {
      id: '/_app/purchasing/$id'
      path: '/$id'
      fullPath: '/purchasing/$id'
      preLoaderRoute: typeof AppPurchasingIdRouteImport
      parentRoute: typeof AppPurchasingRoute
    }
    '/_app/purchasing/import': {
      id: '/_app/purchasing/import'
      path: '/import'
      fullPath: '/purchasing/import'
      preLoaderRoute: typeof AppPurchasingImportRouteImport
      parentRoute: typeof AppPurchasingRoute
    }
    '/_app/purchasing/new': {
      id: '/_app/purchasing/new'
      path: '/new'
      fullPath: '/purchasing/new'
      preLoaderRoute: typeof AppPurchasingNewRouteImport
      parentRoute: typeof AppPurchasingRoute
    }
    '/_app/purchasing/receive': {
      id: '/_app/purchasing/receive'
      path: '/receive'
      fullPath: '/purchasing/receive'
      preLoaderRoute: typeof AppPurchasingReceiveRouteImport
      parentRoute: typeof AppPurchasingRoute
    }
    '/_app/purchasing_/follow-ups': {
      id: '/_app/purchasing_/follow-ups'
      path: '/purchasing/follow-ups'
      fullPath: '/purchasing/follow-ups'
      preLoaderRoute: typeof AppPurchasingFollowUpsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing_/freight': {
      id: '/_app/purchasing_/freight'
      path: '/purchasing/freight'
      fullPath: '/purchasing/freight'
      preLoaderRoute: typeof AppPurchasingFreightRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing_/guide': {
      id: '/_app/purchasing_/guide'
      path: '/purchasing/guide'
      fullPath: '/purchasing/guide'
      preLoaderRoute: typeof AppPurchasingGuideRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/label-templates': {
      id: '/_app/settings_/label-templates'
      path: '/settings/label-templates'
      fullPath: '/settings/label-templates'
      preLoaderRoute: typeof AppSettingsLabelTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/quick-panel': {
      id: '/_app/settings_/quick-panel'
      path: '/settings/quick-panel'
      fullPath: '/settings/quick-panel'
      preLoaderRoute: typeof AppSettingsQuickPanelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system/': {
      id: '/_app/system/'
      path: '/'
      fullPath: '/system/'
      preLoaderRoute: typeof AppSystemIndexRouteImport
      parentRoute: typeof AppSystemRoute
    }
    '/_app/system/floor-devices': {
      id: '/_app/system/floor-devices'
      path: '/floor-devices'
      fullPath: '/system/floor-devices'
      preLoaderRoute: typeof AppSystemFloorDevicesRouteImport
      parentRoute: typeof AppSystemRoute
    }
    '/_app/system/registers': {
      id: '/_app/system/registers'
      path: '/registers'
      fullPath: '/system/registers'
      preLoaderRoute: typeof AppSystemRegistersRouteImport
      parentRoute: typeof AppSystemRoute
    }
    '/_app/system/staff': {
      id: '/_app/system/staff'
      path: '/staff'
      fullPath: '/system/staff'
      preLoaderRoute: typeof AppSystemStaffRouteImport
      parentRoute: typeof AppSystemRoute
    }
    '/_app/system/sync': {
      id: '/_app/system/sync'
      path: '/sync'
      fullPath: '/system/sync'
      preLoaderRoute: typeof AppSystemSyncRouteImport
      parentRoute: typeof AppSystemRoute
    }
    '/_app/transactions_/$id': {
      id: '/_app/transactions_/$id'
      path: '/transactions/$id'
      fullPath: '/transactions/$id'
      preLoaderRoute: typeof AppTransactionsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vendors/$id': {
      id: '/_app/vendors/$id'
      path: '/$id'
      fullPath: '/vendors/$id'
      preLoaderRoute: typeof AppVendorsIdRouteImport
      parentRoute: typeof AppVendorsRoute
    }
    '/_app/vendors/cost-approvals': {
      id: '/_app/vendors/cost-approvals'
      path: '/cost-approvals'
      fullPath: '/vendors/cost-approvals'
      preLoaderRoute: typeof AppVendorsCostApprovalsRouteImport
      parentRoute: typeof AppVendorsRoute
    }
    '/_app/vendors/new': {
      id: '/_app/vendors/new'
      path: '/new'
      fullPath: '/vendors/new'
      preLoaderRoute: typeof AppVendorsNewRouteImport
      parentRoute: typeof AppVendorsRoute
    }
    '/_app/vendors_/catalogs': {
      id: '/_app/vendors_/catalogs'
      path: '/vendors/catalogs'
      fullPath: '/vendors/catalogs'
      preLoaderRoute: typeof AppVendorsCatalogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vendors_/drop-off-locations': {
      id: '/_app/vendors_/drop-off-locations'
      path: '/vendors/drop-off-locations'
      fullPath: '/vendors/drop-off-locations'
      preLoaderRoute: typeof AppVendorsDropOffLocationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gift-cards_/batches_/$id': {
      id: '/_app/gift-cards_/batches_/$id'
      path: '/gift-cards/batches/$id'
      fullPath: '/gift-cards/batches/$id'
      preLoaderRoute: typeof AppGiftCardsBatchesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gift-cards_/batches_/new': {
      id: '/_app/gift-cards_/batches_/new'
      path: '/gift-cards/batches/new'
      fullPath: '/gift-cards/batches/new'
      preLoaderRoute: typeof AppGiftCardsBatchesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders_/$id_/pick': {
      id: '/_app/orders_/$id_/pick'
      path: '/orders/$id/pick'
      fullPath: '/orders/$id/pick'
      preLoaderRoute: typeof AppOrdersIdPickRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing_/$id_/invoice': {
      id: '/_app/purchasing_/$id_/invoice'
      path: '/purchasing/$id/invoice'
      fullPath: '/purchasing/$id/invoice'
      preLoaderRoute: typeof AppPurchasingIdInvoiceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing_/guide_/$vendorId': {
      id: '/_app/purchasing_/guide_/$vendorId'
      path: '/purchasing/guide/$vendorId'
      fullPath: '/purchasing/guide/$vendorId'
      preLoaderRoute: typeof AppPurchasingGuideVendorIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system/registers_/$id': {
      id: '/_app/system/registers_/$id'
      path: '/registers/$id'
      fullPath: '/system/registers/$id'
      preLoaderRoute: typeof AppSystemRegistersIdRouteImport
      parentRoute: typeof AppSystemRoute
    }
    '/_app/system/staff_/$id': {
      id: '/_app/system/staff_/$id'
      path: '/staff/$id'
      fullPath: '/system/staff/$id'
      preLoaderRoute: typeof AppSystemStaffIdRouteImport
      parentRoute: typeof AppSystemRoute
    }
  }
}

interface AppPurchasingRouteChildren {
  AppPurchasingIdRoute: typeof AppPurchasingIdRoute
  AppPurchasingImportRoute: typeof AppPurchasingImportRoute
  AppPurchasingNewRoute: typeof AppPurchasingNewRoute
  AppPurchasingReceiveRoute: typeof AppPurchasingReceiveRoute
}

const AppPurchasingRouteChildren: AppPurchasingRouteChildren = {
  AppPurchasingIdRoute: AppPurchasingIdRoute,
  AppPurchasingImportRoute: AppPurchasingImportRoute,
  AppPurchasingNewRoute: AppPurchasingNewRoute,
  AppPurchasingReceiveRoute: AppPurchasingReceiveRoute,
}

const AppPurchasingRouteWithChildren = AppPurchasingRoute._addFileChildren(
  AppPurchasingRouteChildren,
)

interface AppSystemRouteChildren {
  AppSystemFloorDevicesRoute: typeof AppSystemFloorDevicesRoute
  AppSystemRegistersRoute: typeof AppSystemRegistersRoute
  AppSystemStaffRoute: typeof AppSystemStaffRoute
  AppSystemSyncRoute: typeof AppSystemSyncRoute
  AppSystemIndexRoute: typeof AppSystemIndexRoute
  AppSystemRegistersIdRoute: typeof AppSystemRegistersIdRoute
  AppSystemStaffIdRoute: typeof AppSystemStaffIdRoute
}

const AppSystemRouteChildren: AppSystemRouteChildren = {
  AppSystemFloorDevicesRoute: AppSystemFloorDevicesRoute,
  AppSystemRegistersRoute: AppSystemRegistersRoute,
  AppSystemStaffRoute: AppSystemStaffRoute,
  AppSystemSyncRoute: AppSystemSyncRoute,
  AppSystemIndexRoute: AppSystemIndexRoute,
  AppSystemRegistersIdRoute: AppSystemRegistersIdRoute,
  AppSystemStaffIdRoute: AppSystemStaffIdRoute,
}

const AppSystemRouteWithChildren = AppSystemRoute._addFileChildren(
  AppSystemRouteChildren,
)

interface AppVendorsRouteChildren {
  AppVendorsIdRoute: typeof AppVendorsIdRoute
  AppVendorsCostApprovalsRoute: typeof AppVendorsCostApprovalsRoute
  AppVendorsNewRoute: typeof AppVendorsNewRoute
}

const AppVendorsRouteChildren: AppVendorsRouteChildren = {
  AppVendorsIdRoute: AppVendorsIdRoute,
  AppVendorsCostApprovalsRoute: AppVendorsCostApprovalsRoute,
  AppVendorsNewRoute: AppVendorsNewRoute,
}

const AppVendorsRouteWithChildren = AppVendorsRoute._addFileChildren(
  AppVendorsRouteChildren,
)

interface AppRouteChildren {
  AppAccountCreditsRoute: typeof AppAccountCreditsRoute
  AppAssistRoute: typeof AppAssistRoute
  AppCashRoute: typeof AppCashRoute
  AppCustomersRoute: typeof AppCustomersRoute
  AppGiftCardsRoute: typeof AppGiftCardsRoute
  AppInventoryRoute: typeof AppInventoryRoute
  AppLookupRoute: typeof AppLookupRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppOrganizeRoute: typeof AppOrganizeRoute
  AppPricingRoute: typeof AppPricingRoute
  AppProductsRoute: typeof AppProductsRoute
  AppPurchasingRoute: typeof AppPurchasingRouteWithChildren
  AppRecoveryRoute: typeof AppRecoveryRoute
  AppReportsRoute: typeof AppReportsRoute
  AppReturnsRoute: typeof AppReturnsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSystemRoute: typeof AppSystemRouteWithChildren
  AppTransactionsRoute: typeof AppTransactionsRoute
  AppVendorsRoute: typeof AppVendorsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppCustomersNewRoute: typeof AppCustomersNewRoute
  AppGiftCardsIdRoute: typeof AppGiftCardsIdRoute
  AppGiftCardsBatchesRoute: typeof AppGiftCardsBatchesRoute
  AppOrdersIdRoute: typeof AppOrdersIdRoute
  AppOrdersNewRoute: typeof AppOrdersNewRoute
  AppProductsIdRoute: typeof AppProductsIdRoute
  AppProductsFamiliesRoute: typeof AppProductsFamiliesRoute
  AppProductsNewRoute: typeof AppProductsNewRoute
  AppPurchasingFollowUpsRoute: typeof AppPurchasingFollowUpsRoute
  AppPurchasingFreightRoute: typeof AppPurchasingFreightRoute
  AppPurchasingGuideRoute: typeof AppPurchasingGuideRoute
  AppSettingsLabelTemplatesRoute: typeof AppSettingsLabelTemplatesRoute
  AppSettingsQuickPanelRoute: typeof AppSettingsQuickPanelRoute
  AppTransactionsIdRoute: typeof AppTransactionsIdRoute
  AppVendorsCatalogsRoute: typeof AppVendorsCatalogsRoute
  AppVendorsDropOffLocationsRoute: typeof AppVendorsDropOffLocationsRoute
  AppGiftCardsBatchesIdRoute: typeof AppGiftCardsBatchesIdRoute
  AppGiftCardsBatchesNewRoute: typeof AppGiftCardsBatchesNewRoute
  AppOrdersIdPickRoute: typeof AppOrdersIdPickRoute
  AppPurchasingIdInvoiceRoute: typeof AppPurchasingIdInvoiceRoute
  AppPurchasingGuideVendorIdRoute: typeof AppPurchasingGuideVendorIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountCreditsRoute: AppAccountCreditsRoute,
  AppAssistRoute: AppAssistRoute,
  AppCashRoute: AppCashRoute,
  AppCustomersRoute: AppCustomersRoute,
  AppGiftCardsRoute: AppGiftCardsRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppLookupRoute: AppLookupRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppOrganizeRoute: AppOrganizeRoute,
  AppPricingRoute: AppPricingRoute,
  AppProductsRoute: AppProductsRoute,
  AppPurchasingRoute: AppPurchasingRouteWithChildren,
  AppRecoveryRoute: AppRecoveryRoute,
  AppReportsRoute: AppReportsRoute,
  AppReturnsRoute: AppReturnsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSystemRoute: AppSystemRouteWithChildren,
  AppTransactionsRoute: AppTransactionsRoute,
  AppVendorsRoute: AppVendorsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppCustomersNewRoute: AppCustomersNewRoute,
  AppGiftCardsIdRoute: AppGiftCardsIdRoute,
  AppGiftCardsBatchesRoute: AppGiftCardsBatchesRoute,
  AppOrdersIdRoute: AppOrdersIdRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppProductsIdRoute: AppProductsIdRoute,
  AppProductsFamiliesRoute: AppProductsFamiliesRoute,
  AppProductsNewRoute: AppProductsNewRoute,
  AppPurchasingFollowUpsRoute: AppPurchasingFollowUpsRoute,
  AppPurchasingFreightRoute: AppPurchasingFreightRoute,
  AppPurchasingGuideRoute: AppPurchasingGuideRoute,
  AppSettingsLabelTemplatesRoute: AppSettingsLabelTemplatesRoute,
  AppSettingsQuickPanelRoute: AppSettingsQuickPanelRoute,
  AppTransactionsIdRoute: AppTransactionsIdRoute,
  AppVendorsCatalogsRoute: AppVendorsCatalogsRoute,
  AppVendorsDropOffLocationsRoute: AppVendorsDropOffLocationsRoute,
  AppGiftCardsBatchesIdRoute: AppGiftCardsBatchesIdRoute,
  AppGiftCardsBatchesNewRoute: AppGiftCardsBatchesNewRoute,
  AppOrdersIdPickRoute: AppOrdersIdPickRoute,
  AppPurchasingIdInvoiceRoute: AppPurchasingIdInvoiceRoute,
  AppPurchasingGuideVendorIdRoute: AppPurchasingGuideVendorIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
